import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { ActionButtonStyle } from './ActionButtonStyle';

const ActionButton = ({
  theme,
  icon,
  iconPosition,
  text,
  textAlign,
  transition,
  disabled,
  onClick,
}) => {
  const [className, setClassName] = useState('button-element');

  useEffect(() => {
    const currentCClassName = ['button-element'];

    if (theme && theme.length) {
      currentCClassName.push(`${theme}-theme`);
    }

    if (icon && (!text || (text && !text.length))) {
      currentCClassName.push('icon-only');
    }

    if (icon && text && text.length) {
      currentCClassName.push('icon-text');
    }

    if (icon && iconPosition && iconPosition.length) {
      currentCClassName.push(`icon-${iconPosition}`);
    }

    if (textAlign && textAlign.length) {
      currentCClassName.push(`text-align-${textAlign}`);
    }

    if (transition) {
      currentCClassName.push('with-transition');
    }

    setClassName(currentCClassName.join(' '));
  }, [theme, icon, iconPosition, text, textAlign, transition]);

  return (
    <ActionButtonStyle>
      <button
        type="button"
        className={className}
        disabled={disabled}
        onClick={onClick}
      >
        {icon ? <span className="icon">{icon}</span> : null}
        {text && text.length ? <span className="text" style={{display: 'flex', justifyContent: 'center'}}>{text}</span> : null}
      </button>
    </ActionButtonStyle>
  );
};

ActionButton.propTypes = {
  theme: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.node]),
  iconPosition: PropTypes.string,
  text: PropTypes.string,
  textAlign: PropTypes.string,
  disabled: PropTypes.bool,
  transition: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

ActionButton.defaultProps = {
  theme: 'default',
  icon: null,
  iconPosition: 'left',
  text: '',
  textAlign: 'center',
  disabled: false,
  transition: false,
};

export default ActionButton;
